import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Footer from './components/footer'
import Navbar from './components/navbar'
import { SubMenuProvider } from './components/navbar/components/submenu/context/SubMenuContext'

ReactDOM.render(
  <React.StrictMode>
    <SubMenuProvider>
    <Navbar />
    </SubMenuProvider>
    <App />
    <Footer />
  </React.StrictMode>,
  document.getElementById('root')
)
